/**
 * Keeps empty/loading states vertically centered when parent containers do not
 * provide an explicit height.
 */
export const SCRATCH_PLATE_VIEWER_MIN_HEIGHT = 240;
